import {useMutation} from "@tanstack/react-query";
import {create} from "../../../app/setters/create.js";
import {toast} from "react-toastify";

export const useGenerujPdf = () => {

    return useMutation({
        mutationFn: ({url, form}) => create(url, form),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },
        onMutate: () => {
        },
        onSettled: () => {
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },

    })
}